export class ClientTelephone {
    public id: number;
    public ddd: string;
    public number: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/models/client-telephone.ts